import { render, staticRenderFns } from "./BomTreePage.vue?vue&type=template&id=0dcef845&scoped=true&"
import script from "./BomTreePage.vue?vue&type=script&lang=js&"
export * from "./BomTreePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dcef845",
  null
  
)

export default component.exports